import React from 'react';
import {toggleMobileMenu} from '../../actions/header';
import TranslatedComponent from '../../utils/TranslatedComponent';

function toggleMenu(dispatch) {
  dispatch(toggleMobileMenu());
}

class MenuIcon extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <svg id='hamburgerMenuIcon' className='menuIcon' viewBox="0 0 22 16" version="1.1" onClick={toggleMenu.bind(this, this.props.dispatch)} aria-labelledby='menu-title' role='img'>
        <title id='menu-title'>Menu</title>
        <g id="Components" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
          <g id="Headers" transform="translate(-945.000000, -836.000000)" stroke="#FFFFFF" strokeWidth="2">
            <g id="Group-3" transform="translate(946.000000, 836.000000)">
              <path d="M0,8 L20.0100002,8" id="Line"></path>
              <path d="M0,15 L20.0100002,15" id="Line-Copy"></path>
              <path d="M0,1 L20.0100002,1" id="Line-Copy-2"></path>
            </g>
          </g>
        </g>
      </svg>
    )
  }
}

TranslatedComponent(MenuIcon);
module.exports = MenuIcon;



// WEBPACK FOOTER //
// ./client/src/components/header/MenuIcon.jsx